import React, { useState } from "react";
import AddActionPlanDialog from "./AddActionPlanDialog.js";

import { withStyles } from "@mui/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import MuiDialogTitle from "@mui/material/DialogTitle";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import AddIcon from "@mui/icons-material/Add";

import AddButton from "components/CustomButtons/AddButton";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: '16px',
  },
  closeButton: {
    position: "absolute",
    right: '8px',
    top: '8px',
    color: '#9e9e9e',
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

export default function UploadActionPlans({ refetch }) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <AddButton handleSubmit={handleClickOpen}>
        <AddIcon
          fontSize="small"
          style={{
            marginRight: "6px",
          }}
        />
        Nouveau plan d'action
      </AddButton>
      <Dialog
        onClose={handleClose}
        aria-labelledby="addActionPlan-dialog-title"
        fullWidth={true}
        maxWidth="md"
        open={open}
      >
        <DialogTitle id="addActionPlan-dialog-title" onClose={handleClose}>
          Créer un plan d'action
        </DialogTitle>
        <DialogContent dividers>
          <AddActionPlanDialog closeModal={handleClose} refetch={refetch} />
        </DialogContent>
        <DialogActions />
      </Dialog>
    </div>
  );
}
